import React from "react";
import Error from "./common/Error";

const BadRequest = props => {

    return (
        <Error errorStatus={'400'} errorText={'Bad Request'} errorDescription={"Please verify the parameters used in your request"}/>
    );

};

export default BadRequest;